import type { Role } from './types';

/**
 * Who can do what. With no server, these checks (and the manager PIN) only keep the
 * tablet's screens tidy and keep staff out of the manager area — they are a lock on the
 * door, not a bank vault. Anyone with the tablet and a manager's PIN can do anything.
 */

export type Capability =
  /** Count, record what came in / went out, finish the night. */
  | 'count.enter'
  /** Approve nights, ask for recounts, change finished counts, type Micros numbers. */
  | 'count.approve'
  /** Items, prices, the order sheet. */
  | 'items.edit'
  /** Excel files, trends, specials. */
  | 'reports.view'
  /** People, PINs, settings, restoring from Excel. */
  | 'settings.edit';

const MATRIX: Record<Role, ReadonlySet<Capability>> = {
  staff: new Set(['count.enter']),
  manager: new Set(['count.enter', 'count.approve', 'items.edit', 'reports.view']),
  owner: new Set(['count.enter', 'count.approve', 'items.edit', 'reports.view', 'settings.edit']),
};

export function can(role: Role, capability: Capability): boolean {
  return MATRIX[role].has(capability);
}

export const ROLE_LABEL: Record<Role, string> = { staff: 'Staff', manager: 'Manager', owner: 'Owner' };

export function isManagerOrAbove(role: Role): boolean {
  return role === 'manager' || role === 'owner';
}
